import React, { useEffect, useState } from 'react';
import { TranslationKeys } from '../../../core/constants/translationKeys';
import { Reconnect } from '../reconnect';

export function ConnectionLost({ t }) {
  const [isShowConnectionLost, setIsShowConnectionLost] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsShowConnectionLost(true);
    }, 10000);

    return () => clearTimeout(timer);
  }, []);

  if (!isShowConnectionLost) {
    return <Reconnect t={t} />;
  }

  return (
    <div className='no-connection-bl'>
      <i className='icon-no-connection' />
      <p>{t(TranslationKeys.ConnectionLost)}</p>
    </div>
  );
}
